import fetchHandler, { fetchHandlerForm } from './Handler';

// import { Category } from '../../types/cards';

export const createMenu = async (body: any): Promise<any> => {
	console.log(body, '------------->');
	try {
		const response = await fetchHandlerForm({
			method: 'POST',
			endpoint: 'admin/defaultmenu',
			body,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};

export const getAllMenus = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admin/defaultmenu', // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};

export const deleteMenu = async (data: any): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'DELETE',
			endpoint: `admin/defaultmenu/${data}`,
		});
		// if (response) {
		// return await getAllProducts();
		// }
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

// =======================================================
export const updateMenu = async (data: any, id: string): Promise<any> => {
	console.log(data, 'data>>>>>>>>>>>');
	try {
		const response = await fetchHandlerForm({
			method: 'PATCH',
			endpoint: `admin/defaultmenu/${id}`,
			body: data,
		});
		return response;
	} catch (error) {
		// console.error('Error fetching chatbots:', error);
		// throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

export const updateCategoryStatus = async (data: any, id: string): Promise<any> => {
	try {
		const response = await fetchHandlerForm({
			method: 'PATCH',
			endpoint: `category/${id}`,
			body: data,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

export const getSingleCategory = async (id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `category/${id}`,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const deleteContacts = async (id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `category/${id}`,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
